import api from '../../../api/clinique/_remunerations'

export default {
    getTresoreriePaiementAccess() {
        return new Promise((resolve, reject) => {
            api.getTresoreriePaiementAccess().then(resolve, reject)
        })
    },
    getTresorerieRemunerationAccess() {
        return new Promise((resolve, reject) => {
            api.getTresorerieRemunerationAccess().then(resolve, reject)
        })
    },
    getRemunerationsEnAttente(access_token) {
        return new Promise((resolve, reject) => {
            api.getRemunerationsEnAttente(access_token).then(resolve, reject)
        })
    },
    getRemunerationsEnAttenteV2(access_token) {
        return new Promise((resolve, reject) => {
            api.getRemunerationsEnAttenteV2(access_token).then(resolve, reject)
        })
    },
    getPatientsRemunerations(data, access_token) {
        return new Promise((resolve, reject) => {
            api.getPatientsRemunerations(data, access_token).then(resolve, reject)
        })
    },
    updateStatutRemunerations(data, access_token) {
        return new Promise((resolve, reject) => {
            api.updateStatutRemunerations(data, access_token).then(resolve, reject)
        })
    },
    updateStatutRemunerationsV2(data, access_token) {
        return new Promise((resolve, reject) => {
            api.updateStatutRemunerationsV2(data, access_token).then(resolve, reject)
        })
    }
}
